module.exports = __webpack_public_path__ + "static/technologies-investigated-by-companies.5d1ea263.svg";